import { FC, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

interface FadeContainerProps {
  children: React.ReactNode;
  duration?: number;
  delay?: number;
  className?: string;
  inViewTrigger?: boolean;
  animateNow?: boolean;
}

export const FadeContainer: FC<FadeContainerProps> = ({
  children,
  duration = 1,
  delay = 0,
  className,
  inViewTrigger = false,
  animateNow = null,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });

  const shouldAnimate = animateNow ?? (inViewTrigger ? inView : true);

  return (
    <motion.div
      ref={inViewTrigger ? ref : undefined}
      initial={{ opacity: 0 }}
      animate={shouldAnimate ? { opacity: 1 } : {}}
      transition={{ duration, ease: 'easeInOut', delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
